import { atom } from 'nanostores';

export type PatientPanelTabId = string;

export type PatientWorkspaceSearchResource =
  | 'phr:conditions'
  | 'phr:labs'
  | 'phr:medications'
  | 'phr:notes'
  | 'phr:procedures'
  | 'phr:vitals'
  | 'rx:prescriptions'
  | 'care-state:lab-orders';

export interface PatientWorkspaceSearchTarget {
  tabId: PatientPanelTabId;
  resource: PatientWorkspaceSearchResource;
  query: string;
  resultId?: string;
}

export type PatientChatFocusTarget = {
  userId: string;
  conversationId: string;
  messageId: string;
};

/**
 * Programmatic control of the left PatientPanel active tab.
 */
export const $patientPanelSelectedTab = atom<PatientPanelTabId | null>(null);

export function setPatientPanelSelectedTab(tabId: PatientPanelTabId | null): void {
  $patientPanelSelectedTab.set(tabId);
}

/**
 * Programmatic control of the overlay dock active tab.
 */
export const $overlayDockActiveTab = atom<string | null>(null);

export function setOverlayDockActiveTab(tabId: string | null): void {
  $overlayDockActiveTab.set(tabId);
}

/**
 * One-shot navigation request from global search into a workspace tab/resource.
 */
export const $patientWorkspaceSearchTarget = atom<PatientWorkspaceSearchTarget | null>(null);

export function setPatientWorkspaceSearchTarget(target: PatientWorkspaceSearchTarget | null): void {
  $patientWorkspaceSearchTarget.set(target);
}

export function clearPatientWorkspaceSearchTarget(): void {
  $patientWorkspaceSearchTarget.set(null);
}

/**
 * One-shot navigation request to focus a particular chat message.
 */
export const $patientChatFocusTarget = atom<PatientChatFocusTarget | null>(null);

export function clearPatientChatFocusTarget(): void {
  $patientChatFocusTarget.set(null);
}

export function openChatHistoryAtMessage(target: PatientChatFocusTarget): void {
  setOverlayDockActiveTab('chat:primary');
  $patientChatFocusTarget.set(target);
}
